export default {
    main: {
        index: '首  页',
        essay: '随笔记',
        running: '胡乱跑',
        check: '打卡集',
        box: '藏宝盒',
        about: '关于我',
        Travelling: '开  往',
        TravellingInfo: '开往-友链接力',
        foreverInfo: '穿梭虫洞-随机访问十年之约友链博客'
    },
    maintenance: {
        info: '小破站已运行',
        day: '天',
        lang: '语言'
    },
    statistics: {
        info: '一个腿菜的长跑爱好者',
        essayCount: '文章数',
        checkCount: '跑步打卡',
        mileageCount: '跑步里程',
        raceCount: '比赛次数',
        medalsCount: '奖牌数'
    },
    personal: {
        hometown: '家乡',
        hometownAddress: '山西·临汾',
        live: '现居',
        liveAddress: '浙江·宁波',
        index: '主页',
        hobby: '爱好',
        running: '胡乱跑',
    },
    first: {
        one: '这 只 是 一 个 比 较 神 奇 的 网 站 。',
        two: '或 许 简 陋 。',
        three: '不 过 不 要 着 急 划 走 。',
        four: '留 下 来 转 一 转 也 许 会 有 惊 喜 。',
    },
    foot: {
        author: '作者 : 小七 Copyright © 2023-2024 [https://xqcc.site]',
        ipc: '浙ICP备2023028138号-1',
        mpc: '萌ICP备20247117号',
        forever: '于2024-08-25正式加入十年之约'
    },
    contact: {
        wechat: '微信',
        qq: 'QQ',
        foot: '.联系我.',
        tens: '十年之约'
    }
}